import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { CONTACT, IMG } from "../data/content";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "Mega Celebrity Events respects your privacy. Information you share through our event brief forms, talent enquiries, callback requests, phone calls or WhatsApp messages is used solely to respond to your enquiry and plan your event.",
      "We do not sell, rent or share your personal information with third parties except where required to deliver services you have requested, or where required by law.",
      "Enquiry details are stored securely and accessed only by our event coordination team. You may request correction or deletion of your information at any time by contacting us.",
      `Contact: ${CONTACT.phonePrimary} · ${CONTACT.email}`,
    ],
  },
  terms: {
    title: "Terms of Service",
    body: [
      "All event services provided by Mega Celebrity Events are subject to a written agreement covering scope, timelines, deliverables and commercial terms.",
      "Celebrity and artist participation is always subject to direct confirmation, availability, contracts and applicable permissions. Nothing on this website constitutes a guarantee of any artist's availability.",
      "Estimates and proposals are prepared after reviewing your event requirements. Quotations shared before a requirements review are indicative only.",
      "Content on this website, including text and imagery, may not be reproduced without written permission.",
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    body: [
      "Mega Celebrity Events is an event experience, celebrity coordination and production company. We do not claim official representation of any film personality, artist or public figure unless a written agreement exists.",
      "Some imagery on this website is representative, used to illustrate the style and scale of experiences we create. Client work is published only with permission.",
      "Talent availability, fees, travel, hospitality, technical riders and commercial terms are subject to direct confirmation and contract.",
      "Event outcomes depend on venue conditions, permissions, weather, third-party vendors and other factors; commitments are defined in individual event agreements.",
    ],
  },
};

export default function Legal({ type }) {
  const c = CONTENT[type] || CONTENT.privacy;
  return (
    <main>
      <PageHero eyebrow="Mega Celebrity Events" title={c.title} image={IMG.dimStage} />
      <section className="py-20 lg:py-28">
        <div className="max-w-3xl mx-auto px-4 sm:px-8 space-y-6">
          {c.body.map((p, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <p className="text-[#A9ABB2] leading-relaxed text-sm sm:text-base">{p}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
